(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementDeleteController',AmazonStatementDeleteController);

    AmazonStatementDeleteController.$inject = ['$uibModalInstance', 'entity', 'AmazonStatement'];

    function AmazonStatementDeleteController($uibModalInstance, entity, AmazonStatement) {
        var vm = this;

        vm.amazonStatement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AmazonStatement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
